import { CheckRounded } from '@mui/icons-material';
import { Button } from '@mui/material';

interface AddToCollectionButtonProps {
  isDisabled?: boolean;
}

export const AddToCollectionButton = ({
  isDisabled,
}: AddToCollectionButtonProps) => {
  return (
    <Button
      variant="text"
      color="success"
      size="small"
      startIcon={<CheckRounded />}
      disabled={isDisabled}
    >
      Add
    </Button>
  );
};
